import React from 'react';
import './Blog.css';
import BlogPost from './BlogPost';
import BlogPost0 from './BlogPost0';
import BlogPost2 from './BlogPost2';
import BlogPost3 from './BlogPost3';
import BlogPost4 from './BlogPost4';
import BlogPost5 from './BlogPost5';
import BlogPost6 from './BlogPost6';
import BlogPost7 from './BlogPost7';


class Blog extends React.Component {
  render() {
    return (
      <div className="blog">
        <div className="blog-padding">

          <BlogPost7/>

          <BlogPost6/>

          <BlogPost5/>

          <BlogPost4/>

          <BlogPost/>

          <BlogPost2/>

          <BlogPost0/>
          
          <BlogPost3/>
        </div>
      </div>
    )
  }
}

export default Blog;


// WEBPACK FOOTER //
// ./src/components/blog/Blog.js